// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file task/v1/task.proto (package task.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { User } from "../../base/v1/user_pb.js";
import { Media } from "../../media/v1/media_pb.js";
import { Project } from "../../project/v1/project_pb.js";

/**
 * @generated from enum task.v1.RemarkType
 */
export const RemarkType = /*@__PURE__*/ proto3.makeEnum(
  "task.v1.RemarkType",
  [
    {no: 0, name: "REMARK_TYPE_INVALID", localName: "INVALID"},
    {no: 1, name: "REMARK_TYPE_MANAGER", localName: "MANAGER"},
    {no: 2, name: "REMARK_TYPE_OWNER", localName: "OWNER"},
    {no: 3, name: "REMARK_TYPE_FUTURE_PRECAUTION", localName: "FUTURE_PRECAUTION"},
  ],
);

/**
 * @generated from enum task.v1.TaskStatus
 */
export const TaskStatus = /*@__PURE__*/ proto3.makeEnum(
  "task.v1.TaskStatus",
  [
    {no: 0, name: "TASK_STATUS_INVALID", localName: "INVALID"},
    {no: 1, name: "TASK_STATUS_OPEN", localName: "OPEN"},
    {no: 2, name: "TASK_STATUS_IN_PROGRESS", localName: "IN_PROGRESS"},
    {no: 3, name: "TASK_STATUS_CLOSED", localName: "CLOSED"},
  ],
);

/**
 * @generated from enum task.v1.ComplainType
 */
export const ComplainType = /*@__PURE__*/ proto3.makeEnum(
  "task.v1.ComplainType",
  [
    {no: 0, name: "COMPLAIN_TYPE_INVALID", localName: "INVALID"},
    {no: 1, name: "COMPLAIN_TYPE_COMMON", localName: "COMMON"},
    {no: 2, name: "COMPLAIN_TYPE_INDIVIDUAL", localName: "INDIVIDUAL"},
  ],
);

/**
 * @generated from enum task.v1.PriorityType
 */
export const PriorityType = /*@__PURE__*/ proto3.makeEnum(
  "task.v1.PriorityType",
  [
    {no: 0, name: "PRIORITY_TYPE_INVALID", localName: "INVALID"},
    {no: 1, name: "PRIORITY_TYPE_LOW", localName: "LOW"},
    {no: 2, name: "PRIORITY_TYPE_HIGH", localName: "HIGH"},
    {no: 3, name: "PRIORITY_TYPE_CRITICAL", localName: "CRITICAL"},
  ],
);

/**
 * @generated from enum task.v1.DefectLiabilityType
 */
export const DefectLiabilityType = /*@__PURE__*/ proto3.makeEnum(
  "task.v1.DefectLiabilityType",
  [
    {no: 0, name: "DEFECT_LIABILITY_TYPE_INVALID", localName: "INVALID"},
    {no: 1, name: "DEFECT_LIABILITY_TYPE_FREE", localName: "FREE"},
    {no: 2, name: "DEFECT_LIABILITY_TYPE_PAID", localName: "PAID"},
  ],
);

/**
 * @generated from enum task.v1.LogType
 */
export const LogType = /*@__PURE__*/ proto3.makeEnum(
  "task.v1.LogType",
  [
    {no: 0, name: "LOG_TYPE_INVALID", localName: "INVALID"},
    {no: 1, name: "LOG_TYPE_WORK", localName: "WORK"},
    {no: 2, name: "LOG_TYPE_CLOSURE", localName: "CLOSURE"},
    {no: 3, name: "LOG_TYPE_CREATED", localName: "CREATED"},
    {no: 4, name: "LOG_TYPE_ASSIGNED", localName: "ASSIGNED"},
    {no: 5, name: "LOG_TYPE_REASSIGNED", localName: "REASSIGNED"},
    {no: 6, name: "LOG_TYPE_CLOSED", localName: "CLOSED"},
    {no: 7, name: "LOG_TYPE_CLOSURE_REJECTED", localName: "CLOSURE_REJECTED"},
    {no: 8, name: "LOG_TYPE_MANAGER_REMARK", localName: "MANAGER_REMARK"},
  ],
);

/**
 * @generated from enum task.v1.LogStatus
 */
export const LogStatus = /*@__PURE__*/ proto3.makeEnum(
  "task.v1.LogStatus",
  [
    {no: 0, name: "LOG_STATUS_INVALID", localName: "INVALID"},
    {no: 1, name: "LOG_STATUS_IN_REVIEW", localName: "IN_REVIEW"},
    {no: 2, name: "LOG_STATUS_ACCEPTED", localName: "ACCEPTED"},
    {no: 3, name: "LOG_STATUS_REJECTED", localName: "REJECTED"},
  ],
);

/**
 * @generated from message task.v1.Remark
 */
export const Remark = /*@__PURE__*/ proto3.makeMessageType(
  "task.v1.Remark",
  () => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(RemarkType) },
    { no: 4, name: "user", kind: "message", T: User },
    { no: 5, name: "media", kind: "message", T: Media, repeated: true },
    { no: 6, name: "date_created", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message task.v1.TaskDetail
 */
export const TaskDetail = /*@__PURE__*/ proto3.makeMessageType(
  "task.v1.TaskDetail",
  () => [
    { no: 1, name: "owner_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "flat_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "contact_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "complain_type", kind: "enum", T: proto3.getEnumType(ComplainType) },
    { no: 7, name: "priority", kind: "enum", T: proto3.getEnumType(PriorityType) },
    { no: 8, name: "defect_liability", kind: "enum", T: proto3.getEnumType(DefectLiabilityType) },
    { no: 9, name: "complain_category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "vendor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "date_of_completion", kind: "message", T: Timestamp },
    { no: 12, name: "report_to_admin", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "manager_remarks", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "owner_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message task.v1.Task
 */
export const Task = /*@__PURE__*/ proto3.makeMessageType(
  "task.v1.Task",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "project", kind: "message", T: Project },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(TaskStatus) },
    { no: 5, name: "created_by", kind: "message", T: User },
    { no: 6, name: "managed_by", kind: "message", T: User },
    { no: 7, name: "supervisor", kind: "message", T: User },
    { no: 8, name: "assigned_on", kind: "message", T: Timestamp },
    { no: 9, name: "detail", kind: "message", T: TaskDetail },
    { no: 10, name: "logs", kind: "message", T: Log, repeated: true },
    { no: 11, name: "closure_requested", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "closed_on", kind: "message", T: Timestamp },
    { no: 13, name: "medias", kind: "message", T: Media, repeated: true },
    { no: 14, name: "remarks", kind: "message", T: Remark, repeated: true },
    { no: 15, name: "created_at", kind: "message", T: Timestamp },
    { no: 16, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message task.v1.Log
 */
export const Log = /*@__PURE__*/ proto3.makeMessageType(
  "task.v1.Log",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "type", kind: "enum", T: proto3.getEnumType(LogType) },
    { no: 5, name: "status", kind: "enum", T: proto3.getEnumType(LogStatus) },
    { no: 6, name: "remark", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "user", kind: "message", T: User },
    { no: 8, name: "assigned_supervisor", kind: "message", T: User, opt: true },
    { no: 9, name: "remark_by", kind: "message", T: User, opt: true },
    { no: 10, name: "medias", kind: "message", T: Media, repeated: true },
    { no: 11, name: "created_at", kind: "message", T: Timestamp },
    { no: 12, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

